import { render, staticRenderFns } from "./IconEllipse.vue?vue&type=template&id=6caf345c&scoped=true"
import script from "./IconEllipse.vue?vue&type=script&lang=js"
export * from "./IconEllipse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caf345c",
  null
  
)

export default component.exports